import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { AppService } from "src/app/core/services/app.service";
import { FocuslinkService } from "src/app/core/services/focuslink.service";
import { OOVenueService } from "src/app/core/services/venue-service";
import { AppMessageSeverity } from "src/app/shared/models/enums/AppMessageSeverity.enum";

@Component({
	selector: "app-integration-ubereats-setup",
	templateUrl: "./integration-ubereats-setup.component.html",
	styleUrls: ["../../../commandcenter.scss"],
})
export class IntegrationUbereatsSetupComponent implements OnInit {
	@Input() changesToSave: boolean;
	@Output() changesToSaveChange = new EventEmitter<boolean>();

	loadingUber: boolean = false;

	uber: any = {};
	uberStoreId: string;
	uberStatus: any;
	uberUnauthorized: boolean = false;

	constructor(public app: AppService, public venueSvc: OOVenueService, private focuslink: FocuslinkService) {}

	ngOnInit(): void {
		this.uberInit();
		this.uberStatusGet(this.venueSvc.venueKey);
	}

	async uberConnect() {
		// const clientId = 'cHTYj_Mp9OUK8Xaiby7fOlC-FKbONZEi';
		const clientId = "VC6Jy2atqBqfp-5gnet-OTfUhn-QpBOi";
		let redirectUri = window.location.hostname;
		if (redirectUri === "localhost") {
			redirectUri = `http://localhost:4200`;
		} else {
			redirectUri = `https://${redirectUri}`;
			if (!redirectUri.includes("onlineorder.focuspos.com")) {
				redirectUri = "https://onlineorder.focuspos.com";
			}
		}
		const state = btoa(
			JSON.stringify({
				venueKey: this.venueSvc.venueKey,
				appId: "uber",
				redirectUri: redirectUri,
			})
		);
		const uberUrl = `https://login.uber.com/oauth/v2/authorize?response_type=code&client_id=${clientId}&redirect_uri=${redirectUri}&state=${state}&scope=eats.pos_provisioning`;
		window.open(uberUrl, "_blank");
	}

	async uberPosToggle() {
		if (this.uberStatus.posStatus.pos_integration_enabled) {
			this.uberStatus = await this.focuslink.uberChangePosStatus(this.venueSvc.venueKey, false, false);
		} else {
			this.uberStatus = await this.focuslink.uberChangePosStatus(this.venueSvc.venueKey, true, false);
		}
	}

	async uberLinkStore(id: string) {
		this.loadingUber = true;
		try {
			await this.focuslink.uberSetupPos(this.venueSvc.ooVenue.venueKey, id);
			this.loadingUber = false;
			this.app.msgSvc.add({ severity: "success", detail: "Success" });
		} catch (error) {
			this.loadingUber = false;
			this.app.msgSvc.add({ severity: "error", detail: "Error linking store" });
			console.error(error);
		}
	}

	async uberInit() {
		const iUber = this.venueSvc.getIntegration("uber");
		if (iUber && iUber.status) {
			this.uber.stores = await this.focuslink.getUberStores(this.venueSvc.venueKey);
			this.uber.stores = this.uber.stores.stores?.map((s) => ({
				label: s.name,
				value: s.store_id,
			}));
			this.uber.stores?.unshift({
				label: "None",
				value: null,
			});
		}
	}

	async uberDelete() {
		this.app.confirmation.confirm({
			message: `Are you sure you want to remove the UberEats integration? This cannot be undone.`,
			accept: async () => {
				await this.focuslink.uberDeleteIntegration(this.venueSvc.venueKey);
				this.app.msgSvc.add({ severity: AppMessageSeverity.GREEN, summary: "", detail: `UberEats integration terminated.` });
				this.venueSvc.ooVenue.uberStoreId = undefined;
			},
			reject: async () => {
				this.app.confirmation.close();
			},
		});
	}

	async uberStatusGet(venueKey) {
		try {
			const resp = await this.focuslink.uberStatus(venueKey);
			this.uberStatus = resp;
		} catch (error) {
			if (error.status === 401) {
				this.uberUnauthorized = true;
			}
		}
	}

	async uploadUberMenu() {
		this.loadingUber = true;
		try {
			await this.focuslink.uploadUberMenus(this.venueSvc.ooVenue.venueKey, this.venueSvc.ooVenue.uberOOMenuKey || "0");
			this.loadingUber = false;
			this.app.msgSvc.add({ severity: "success", detail: "Success" });
		} catch (error) {
			this.app.msgSvc.add({ severity: "error", detail: "Error uploading Uber menu" });
			this.app.msgSvc.add({ severity: "error", detail: error.error.error });
			console.error(error);
		}
	}
}
